import React, { memo } from 'react';
import classNames from 'classnames';
import { Box, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(({ palette }) => ({
  chip: {
    width: 160,
    height: 20,
    color: palette.common.white,
    backgroundColor: palette.teal.main,
    borderRadius: 2,
    fontSize: 12,
    lineHeight: 1.33,
    fontWeight: 'bold',
  },
  factInfo: {
    wordBreak: 'break-word',
  },
}));

export interface IFunFactsProps {
  facts: string;
}

const FunFacts = ({ facts }: IFunFactsProps) => {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={['flex-start', 'center']}
      width={1}
      mt={[1, 4]}
      fontSize={16}
      fontFamily="Lato"
      data-testid="giftSenderFunFacts"
    >
      <Chip className={classNames('funFacts-ie', classes.chip)} label="MY #5to9 FUN FACTS" />
      <Box
        mt={1}
        width={1}
        maxWidth={['100%', 300]}
        color="common.black"
        fontSize={[12, 16]}
        textAlign={['left', 'center']}
        className={classes.factInfo}
      >
        {facts}
      </Box>
    </Box>
  );
};

export default memo(FunFacts);
